export const CARD =
  'overflow-hidden rounded-[12px] border border-gray-200 bg-white shadow-[0_1px_2px_rgba(24,33,47,0.04)]';

export const CHIP =
  'inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[12px] font-gilroy-medium';

export const BUTTON =
  'inline-flex h-8 shrink-0 cursor-pointer items-center rounded-full border border-gray-200 bg-white px-3 text-[13px] font-gilroy-medium text-neutral-500 transition-colors hover:bg-creams-200 disabled:cursor-default disabled:opacity-50';

export const BUTTON_DARK =
  'inline-flex h-8 shrink-0 cursor-pointer items-center rounded-full bg-neutral-500 px-3 text-[13px] font-gilroy-medium text-white transition-colors hover:bg-neutral-400 disabled:cursor-default disabled:opacity-50';

export const titleCase = (value: string): string =>
  (value || '').replace(/_/g, ' ').replace(/^./, (c: string) => c.toUpperCase());

export function duration(ms: number): string {
  const m = Math.max(0, Math.round(Math.abs(ms) / 60_000));
  const d = Math.floor(m / 1440);
  const h = Math.floor((m % 1440) / 60);
  const min = m % 60;
  if (d) return h ? `${d}d ${h}h` : `${d}d`;
  if (h) return min ? `${h}h ${min}m` : `${h}h`;
  return `${min}m`;
}
